/* @ngInject */
function flagIconDirective(cdnDomain: string): Record<string, any> {
	return {
		restrict: "A",
		scope: {
			countryCode: "=flagIconCountry"
		},
		link: function (scope, element, attrs) {
			function applySrc() {
				if (scope.countryCode) {
					attrs.$set("src", `${cdnDomain}/images/flagsquares/${scope.countryCode.toUpperCase()}.png`);
				} else {
					// TODO throw some sort of error
					console.log("flag-icon directive failed - invalid country code " + scope.countryCode);
				}
			}

			applySrc();
			scope.$watch("countryCode", applySrc);
		}
	};
}

export default flagIconDirective;